const DAY_MS = 24 * 60 * 60 * 1000;

function formatDay(d) {
	return d.toLocaleDateString('en-GB', { month: 'short', day: 'numeric' });
}

/**
 * Builds a contiguous 30-day series from the sparse `stock_count` rows for the
 * Inventory accuracy page (uptime strip + upload-history chart).
 *
 * Status per day:
 *   "healthy" — a row exists with meaningful data (in_stock > 0 or uploaded > 0)
 *   "hiccup"  — a row exists but both in_stock and uploaded are 0 (connector
 *               ran but no meaningful data flowed — NEA-5815)
 *   "down"    — no row for a past day (snapshot never landed)
 *   "pending" — no row for today (snapshot hasn't landed yet)
 *
 * The chart value for any missing day is `null` (not 0) so the line bridges
 * the gap via `connectNulls` instead of nose-diving to zero. A genuine zero
 * (a row whose count is 0) still plots as 0.
 *
 * `now` is injectable so the window is deterministic in tests.
 *
 * @returns {{ days: Array, chart: Array }}
 */
function buildSeries(rows, now = new Date()) {
	const byDate = new Map();
	for (const r of rows ?? []) {
		const key = String(r.date).slice(0, 10);
		byDate.set(key, r);
	}
	const days = [];
	const chart = [];
	for (let i = 29; i >= 0; i--) {
		const d = new Date(now.getTime() - i * DAY_MS);
		const key = d.toISOString().slice(0, 10);
		const row = byDate.get(key);
		const label = formatDay(d);
		const inStock = row ? Number(row.in_stock_barcodes ?? 0) : undefined;
		const totalUploaded = row ? Number(row.total_uploaded_barcodes ?? 0) : undefined;
		let status;
		if (!row) {
			status = i === 0 ? 'pending' : 'down';
		} else {
			status = inStock > 0 || totalUploaded > 0 ? 'healthy' : 'hiccup';
		}
		days.push({ date: label, status, inStock, totalUploaded });
		chart.push({ date: label, inStock: inStock ?? null, totalUploaded: totalUploaded ?? null });
	}
	return { days, chart };
}

export { buildSeries, formatDay, DAY_MS };
